import type { Api } from "./api";
import { createHttpApi } from "./http/httpApi";

export const api: Api = createHttpApi(import.meta.env.VITE_API_BASE ?? "/api");

export * from "./api";
